/**
 * טפסי דירוג תחת reviews/site ו-reviews/service — סנכרון MDB Rating לשדה נסתר ושליחה לשרת.
 */
document.addEventListener("DOMContentLoaded", function () {
  var forms = document.querySelectorAll(".br-reviews-form__form");
  if (!forms.length) {
    return;
  }

  function getMdbRatingClass() {
    var m = window.mdb;
    if (!m) {
      return null;
    }
    if (typeof m.Rating === "function") {
      return m.Rating;
    }
    var d = m.default;
    if (d && typeof d.Rating === "function") {
      return d.Rating;
    }
    return null;
  }

  function disposeRatingInstance(ratingEl) {
    var RatingClass = getMdbRatingClass();
    if (!RatingClass || !ratingEl) {
      return;
    }
    try {
      var inst =
        typeof RatingClass.getInstance === "function" ? RatingClass.getInstance(ratingEl) : null;
      if (inst && typeof inst.dispose === "function") {
        inst.dispose();
      }
    } catch (e) {
      /* ignore */
    }
  }

  function reinitBusinessRatings() {
    if (typeof window.businessSitesInitMdbComponents === "function") {
      window.businessSitesInitMdbComponents();
    }
  }

  function notify(payload) {
    if (typeof Toast === "function") {
      Toast(payload);
      return;
    }

    window.alert(payload && payload.message ? payload.message : "הפעולה בוצעה");
  }

  function readRatingEventValue(ev) {
    if (!ev) {
      return null;
    }
    if (typeof ev.value !== "undefined" && ev.value !== null) {
      return ev.value;
    }
    if (ev.detail && typeof ev.detail.value !== "undefined" && ev.detail.value !== null) {
      return ev.detail.value;
    }
    return null;
  }

  forms.forEach(function (form) {
    var ratingEl = form.querySelector("ul.rating[data-mdb-rating-init]");
    var hidden = form.querySelector("input[type=\"hidden\"][data-br-rating-field]");
    var successState = form.parentElement.querySelector("[data-br-review-success-state]");
    var successName = successState ? successState.querySelector("[data-br-review-success-name]") : null;
    if (!ratingEl || !hidden) {
      return;
    }

    function bindRatingSync(ratingUl, hiddenInput) {
      function sync(ev) {
        var val = readRatingEventValue(ev);
        if (val != null) hiddenInput.value = String(val);
      }
      ratingUl.addEventListener("scoreSelect.mdb.rating", sync);
      ratingUl.querySelectorAll("i").forEach(function (icon) {
        icon.addEventListener("scoreSelect.mdb.rating", sync);
      });
    }

    bindRatingSync(ratingEl, hidden);

    var serviceRatingPairs = [];
    var serviceHiddens = form.querySelectorAll('input[type="hidden"][name^="service_rating["]');
    serviceHiddens.forEach(function (svcHidden) {
      var wrapper = svcHidden.closest(".col-12, .col-sm-6, .col-6");
      if (!wrapper) wrapper = svcHidden.parentElement;
      var svcRatingUl = wrapper ? wrapper.querySelector("ul.rating[data-mdb-rating-init]") : null;
      if (svcRatingUl) {
        bindRatingSync(svcRatingUl, svcHidden);
        serviceRatingPairs.push(svcHidden);
      }
    });

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      if (!hidden.value || hidden.value === "0") {
        notify({ message: "נא לבחור דירוג כוכבים", status: "error", delay: 2200 });
        return;
      }

      var formData = new FormData();
      formData.append("module", "Reviews");
      formData.append("action", "SubmitReview");
      formData.append("rating", hidden.value);

      var targetType = form.querySelector('input[name="target_type"]');
      var targetId = form.querySelector('input[name="target_id"]');
      var userIdField = form.querySelector('input[name="user_id"]');
      var titleField = form.querySelector('input[name="title"]');
      var commentField = form.querySelector('textarea[name="comment"]');
      var displayName = form.querySelector('input[name="display_name"]');

      formData.append("target_type", targetType ? targetType.value : "business");
      formData.append("target_id", targetId ? targetId.value : "0");
      formData.append("user_id", userIdField ? userIdField.value : "0");
      formData.append("title", titleField ? titleField.value.trim() : "");
      formData.append("comment", commentField ? commentField.value.trim() : "");
      if (displayName && displayName.value.trim()) {
        formData.append("display_name", displayName.value.trim());
      }

      serviceRatingPairs.forEach(function (svcHidden) {
        if (svcHidden.value && svcHidden.value !== "0") {
          formData.append(svcHidden.name, svcHidden.value);
        }
      });

      if (typeof BSID !== "undefined" && BSID) {
        formData.append("bsid", BSID);
      }

      try {
        var response = await fetch("/api/", {
          method: "POST",
          credentials: "same-origin",
          body: formData,
        });
        var payload = await response.json();
        if (!response.ok || !payload || payload.status !== "success") {
          notify({
            message: (payload && (payload.message || payload.messages)) || "התרחשה שגיאה זמנית",
            status: "error",
            delay: (payload && payload.delay) || 3200,
          });
          return;
        }

        notify({
          message: payload.message || "תודה רבה. חוות הדעת נשלחה בהצלחה.",
          status: "success",
          delay: payload.delay || 3600,
        });
        if (successName) {
          var userNameField = form.querySelector('input[name="display_name"]');
          successName.textContent = userNameField ? userNameField.value.trim() : "";
        }
        form.classList.add("d-none");
        if (successState) {
          successState.classList.remove("d-none");
        }
        form.reset();
        hidden.value = "";
        disposeRatingInstance(ratingEl);
        reinitBusinessRatings();
      } catch (error) {
        notify({
          message: "התרחשה שגיאה זמנית בשליחת חוות הדעת",
          status: "error",
          delay: 3200,
        });
        return;
      }
    });
  });
});
